import classNames from "classnames";
import EmailLogo from "images/mail.svg?react";
import AuthButton from "../AuthButton";
import "./style.css";

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}

export default function EmailButton({ children, className, onClick }: Props) {
  return (
    <AuthButton
      buttonClass={classNames(className, "email-button")}
      imageClass="email-logo"
      textClass="email-text"
      logo={EmailLogo}
      onClick={onClick}
    >
      {children}
    </AuthButton>
  );
}
